export default __webpack_public_path__ + "static/media/typcn_delete.8805be5f.svg";